import { createAction, props } from '@ngrx/store';

export enum CompanyLogoActions {
  CompanyLogoRequested = '[CompanyProfile] Company Logo Requested',
  CompanyLogoLoaded = '[CompanyLogo] Company Logo Loaded',
  CompanyLogoError = '[CompanyLogo] Company Logo Error'
}

export const CompanyLogoRequested = createAction(CompanyLogoActions.CompanyLogoRequested);

export const CompanyLogoLoaded = createAction(CompanyLogoActions.CompanyLogoLoaded,
  props<{ logo: string | null }>());

export const CompanyLogoError = createAction(CompanyLogoActions.CompanyLogoError);
